import React from "react";

export default function PistaF1({ venue_name, venue_state, venue_country, circuit_image, opta_event_url }) {

    return (
        <a className="pista-elementos-f1" href={opta_event_url} target="_top">

            <div className="container-pista">
                <img src={circuit_image} alt="img-circuto" loading="lazy"></img>
            </div>

            <div className="container-address">
                <p className="address">{venue_name}{venue_name ? "," : ""}<br></br> {venue_state}{venue_state ? "," : ""}<br></br> {venue_country} </p>
            </div>

        </a>
    )
}